var _circle, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentSuccessPopupIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#50B83C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.5625 18.75C68.8214 18.75 82.8125 32.7411 82.8125 50C82.8125 67.2589 68.8214 81.25 51.5625 81.25C34.3036 81.25 20.3125 67.2589 20.3125 50C20.3125 32.7411 34.3036 18.75 51.5625 18.75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.1925 25.6836C78.2804 31.4124 82.813 40.1771 82.813 50.0005C82.813 67.2594 68.8219 81.2505 51.563 81.2505C41.7396 81.2505 32.9749 76.7179 27.2461 69.63C32.6111 73.9662 39.44 76.563 46.8755 76.563C64.1344 76.563 78.1255 62.5719 78.1255 45.313C78.1255 37.8775 75.5287 31.0486 71.1925 25.6836V25.6836Z",
    fill: "#FFC200"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5625 17.1875C69.6843 17.1875 84.375 31.8782 84.375 50C84.375 68.1218 69.6843 82.8125 51.5625 82.8125C33.4407 82.8125 18.75 68.1218 18.75 50C18.75 31.8782 33.4407 17.1875 51.5625 17.1875ZM51.5625 20.3125C35.1665 20.3125 21.875 33.604 21.875 50C21.875 66.396 35.1665 79.6875 51.5625 79.6875C67.9585 79.6875 81.25 66.396 81.25 50C81.25 33.604 67.9585 20.3125 51.5625 20.3125Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.1925 25.6836C78.2804 31.4124 82.813 40.1771 82.813 50.0005C82.813 67.2594 68.8219 81.2505 51.563 81.2505C41.7396 81.2505 32.9749 76.7179 27.2461 69.63C32.6111 73.9662 39.44 76.563 46.8755 76.563C64.1344 76.563 78.1255 62.5719 78.1255 45.313C78.1255 37.8775 75.5287 31.0486 71.1925 25.6836V25.6836Z",
    fill: "#50B83C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.5625 17.1875C69.6843 17.1875 84.375 31.8782 84.375 50C84.375 68.1218 69.6843 82.8125 51.5625 82.8125C33.4407 82.8125 18.75 68.1218 18.75 50C18.75 31.8782 33.4407 17.1875 51.5625 17.1875ZM51.5625 20.3125C35.1665 20.3125 21.875 33.604 21.875 50C21.875 66.396 35.1665 79.6875 51.5625 79.6875C67.9585 79.6875 81.25 66.396 81.25 50C81.25 33.604 67.9585 20.3125 51.5625 20.3125Z",
    fill: "#50B83C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.4399 57.063L40.127 48.8571C39.5128 48.2509 38.5235 48.2573 37.9173 48.8714C37.3111 49.4855 37.3175 50.4748 37.9316 51.0811L47.4602 60.487C48.1134 61.1318 49.1789 61.0774 49.7631 60.3695L65.2345 41.6195C65.7837 40.9539 65.6894 39.9691 65.0237 39.4199C64.3581 38.8706 63.3733 38.965 62.8241 39.6306L48.4399 57.063Z",
    fill: "#50B83C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentSuccessPopupIcon);
export default __webpack_public_path__ + "static/media/payment-success-popup-icon.78c6313ca8e7df1ffb8c923b13eb37d7.svg";
export { ForwardRef as ReactComponent };